import { render, staticRenderFns } from "./YourFavsContainer.vue?vue&type=template&id=4bb11826&scoped=true&"
import script from "./YourFavsContainer.vue?vue&type=script&lang=ts&"
export * from "./YourFavsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./YourFavsContainer.vue?vue&type=style&index=0&id=4bb11826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb11826",
  null
  
)

export default component.exports